import { View } from "./View";

export interface ISectionHeaderProps {
  title: string;
  subtitle: string;
}

export const SectionHeader = (props: ISectionHeaderProps) => {
  return <View {...props} />;
};
